import { Link, useParams } from 'react-router-dom';
import apiMethod from '../../../services/api-service';
import methods from '../../../services/utility';
import { useState, useEffect } from 'react';

// assets
import back from "../../../assets/images/icons/arrow-right2.svg";
import Preloading from '../../../components/basics/Preloading';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'
import CreditDetailModal from './CreditDetailModal';

const CashDeskOffRecord = () => {
  const { branchId, deskId } = useParams();
  const [activityId, setActivityId] = useState()
  const [show, setShow] = useState();
  const [creditDetailData, setCreditDetailData] = useState([])
  const [gridData, setGridData] = useState([]);
  const [cashDeskInfo, setCashDeskInfo] = useState([]);
  const [cashdeskReport, setCashdeskReport] = useState({
    cashDeskId: deskId,
    posDetails: [],
    totalPosAmount: 0,
    posBalance: 0,
    presence: {
      netAmount: 0,
      taxAmount: 0,
      tipAmount: 0,
      discountAmount: 0,
      finalAmount: 0,
      paymentAmount: 0
    },
    salon: {
      netAmount: 0,
      taxAmount: 0,
      tipAmount: 0,
      discountAmount: 0,
      finalAmount: 0,
      paymentAmount: 0
    },
    delivery: {
      netAmount: 0,
      taxAmount: 0,
      tipAmount: 0,
      discountAmount: 0,
      finalAmount: 0,
      paymentAmount: 0
    },
    snapp: {
      netAmount: 0,
      taxAmount: 0,
      tipAmount: 0,
      discountAmount: 0,
      finalAmount: 0,
      paymentAmount: 0
    },
    delino: {
      netAmount: 0,
      taxAmount: 0,
      tipAmount: 0,
      discountAmount: 0,
      finalAmount: 0,
      paymentAmount: 0
    },
    credit: {
      netAmount: 0,
      taxAmount: 0,
      tipAmount: 0,
      discountAmount: 0,
      finalAmount: 0,
      paymentAmount: 0
    },
    unpaidInvoices: {
      totalCount: 0,
      totalFinalPrice: 0
    },
    guestAmount: 0,
    totalLegalAmount: 0,
    creditUserDetail: [],
    unitsReport: [],
    cashAmount: 0,
    cashBalance: 0,
    cardToCardAmount: 0,
    cardToCardBalance: 0,
    totalAmount: 0,
    totalPayAmount: 0,
    notPaidAmount: 0,
    discrepancy: 0,
    guestInvoices: [],
    satisfactionInvoices: [],
    foodTestInvoices: [],
    creator: ''
  });
  const [deskActivityInfo, setDeskActivityInfo] = useState({
    cashDeskId: deskId,
    posDetails: [],
    posAmount: 0,
    posBalance: 0,
    presenceDetail: {},
    presenceAmount: 0,
    salonDetail: {},
    salonAmount: 0,
    deliveryDetail: {},
    deliveryAmount: 0,
    snappDetail: {},
    snappAmount: 0,
    delinoDetail: {},
    delinoAmount: 0,
    guestAmount: 0,
    totalLegalAmount: 0,
    totalCreditAmount: 0,
    creditUserDetail: [],
    unitsReport: [],
    cashAmount: 0,
    cashBalance: 0,
    cardToCardAmount: 0,
    cardToCardBalance: 0,
    totalAmount: 0,
    totalPayAmount: 0,
    notPaidAmount: 0,
    discrepancy: 0,
    guestInvoices: [],
    satisfactionInvoices: [],
    foodTestInvoices: [],
    startDate: '',
    endDate: '',
    creator: ''
  });
  const [showCashDeskReportModal, setShowCashDeskReportModal] = useState(false);
  const [showCashDeskActivityModal, setShowCashDeskActivityModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [filterModel, setFilterModel] = useState({
    branchId: branchId,
    deskId: deskId,
    size: 20,
    part: 1,
    total: 0,
    parts: 0
  });

  const mapReportObject = (data) => {
    cashdeskReport.posDetails = data.posDetails;
    cashdeskReport.totalPosAmount = data.totalPosAmount;
    cashdeskReport.posBalance = data.posBalance;
    cashdeskReport.presence = data.presence
    cashdeskReport.salon = data.salon;
    cashdeskReport.delivery = data.delivery;
    cashdeskReport.snapp = data.snapp;
    cashdeskReport.delino = data.delino;
    cashdeskReport.credit = data.credit;
    cashdeskReport.unpaidInvoices = data.unpaidInvoices;
    cashdeskReport.guestAmount = data.guestAmount;
    cashdeskReport.totalLegalAmount = data.totalLegalAmount;
    cashdeskReport.creditUserDetail = data.creditUserDetail;
    cashdeskReport.unitsReport = data.unitsReport;
    cashdeskReport.cashAmount = data.cashAmount;
    cashdeskReport.cashBalance = data.cashBalance;
    cashdeskReport.cardToCardAmount = data.cardToCardAmount;
    cashdeskReport.cardToCardBalance = data.cardToCardBalance;
    cashdeskReport.totalAmount = data.totalAmount;
    cashdeskReport.totalPayAmount = data.totalPayAmount;
    cashdeskReport.notPaidAmount = data.notPaidAmount;
    cashdeskReport.discrepancy = data.discrepancy;
    cashdeskReport.guestInvoices = data.guestInvoices;
    cashdeskReport.satisfactionInvoices = data.satisfactionInvoices;
    cashdeskReport.foodTestInvoices = data.foodTestInvoices;
    cashdeskReport.creator = data.creator;

    setCashdeskReport({ ...cashdeskReport });
  }

  const mapActivity = (data) => {
    deskActivityInfo.posDetails = JSON.parse(data.posDetails);
    deskActivityInfo.posAmount = data.posAmount;
    deskActivityInfo.posBalance = data.posBalance;
    deskActivityInfo.presenceDetail = JSON.parse(data.presenceDetail);
    deskActivityInfo.presenceAmount = data.presenceAmount;
    deskActivityInfo.salonDetail = JSON.parse(data.salonDetail);
    deskActivityInfo.salonAmount = data.salonAmount;
    deskActivityInfo.deliveryDetail = JSON.parse(data.deliveryDetail);
    deskActivityInfo.deliveryAmount = data.deliveryAmount;
    deskActivityInfo.snappDetail = JSON.parse(data.snappDetail);
    deskActivityInfo.snappAmount = data.snappAmount;
    deskActivityInfo.delinoDetail = JSON.parse(data.delinoDetail);
    deskActivityInfo.delinoAmount = data.delinoAmount;
    deskActivityInfo.creditDetail = JSON.parse(data.creditDetail);
    deskActivityInfo.guestAmount = data.guestAmount;
    deskActivityInfo.totalLegalAmount = data.totalLegalAmount;
    deskActivityInfo.totalCreditAmount = data.totalCreditAmount;
    deskActivityInfo.creditUserDetail = JSON.parse(data.creditUserDetail);
    deskActivityInfo.salesUnitObject = JSON.parse(data.salesUnitObject);
    deskActivityInfo.cashAmount = data.cashAmount;
    deskActivityInfo.cashBalance = data.cashBalance;
    deskActivityInfo.cardToCardAmount = data.cardToCardAmount;
    deskActivityInfo.cardToCardBalance = data.cardToCardBalance;
    deskActivityInfo.totalAmount = data.totalAmount;
    deskActivityInfo.totalPayAmount = data.totalPayAmount;
    deskActivityInfo.notPaidAmount = data.notPaidAmount;
    deskActivityInfo.discrepancy = data.discrepancy;
    deskActivityInfo.guestInvoices = JSON.parse(data.guestInvoices);
    deskActivityInfo.satisfactionInvoices = JSON.parse(data.satisfactionInvoices);
    deskActivityInfo.foodTestInvoices = JSON.parse(data.foodTestInvoices);
    deskActivityInfo.description = data.description;
    deskActivityInfo.startDate = data.startDate;
    deskActivityInfo.endDate = data.endDate;
    deskActivityInfo.creator = data.creator;

    setDeskActivityInfo({ ...deskActivityInfo });
  }

  const handleClose = () => setShow(null);

  const getGridData = async (preload) => {
    if (preload)
      setLoading(true);
    const resp = await apiMethod.getDeskActivities(filterModel.deskId, filterModel.size, filterModel.part);
    if (methods.showApiErrors(resp)) {
      filterModel.total = resp.total;
      filterModel.parts = methods.calcPageParts(resp.total, filterModel.size);
      setFilterModel({ ...filterModel });
      setGridData(resp.data);
    }
    if (preload)
      setLoading(false);
  };

  const getCashDeskReport = async () => {
    setLoading(true);
    const resp = await apiMethod.getCashDeskReport(filterModel.deskId);
    setLoading(false);
    if (!methods.showApiErrors(resp))
      return false;

    mapReportObject(resp.data);
    calcdiscrepancy();
  };

  const getCashDeskInfo = async () => {
    const resp = await apiMethod.getCashDeskInfo(filterModel.deskId);
    if (methods.showApiErrors(resp))
      setCashDeskInfo(resp.data);
  }

  const getPosBalanceForCashDesk = async (id, index) => {
    setLoading(true);
    const resp = await apiMethod.getPosSummationReport(id, deskId);
    setLoading(false);
    if (methods.showApiErrors(resp)) {
      cashdeskReport.posDetails[index].posInquiryAmount = resp.sum;
      cashdeskReport.posBalance = cashdeskReport.posDetails.reduce((sum, curr) => sum = sum + curr.posInquiryAmount, 0)
      setCashdeskReport({ ...cashdeskReport });
      calcdiscrepancy();
    }
  };

  useEffect(() => {
    const bindData = async () => {
      setLoading(true);
      await getGridData(false);
      await getCashDeskInfo();
      setLoading(false);
    }
    bindData();
  }, [branchId, deskId]);

  const openCashDesk = async () => {
    setLoading(true);
    const resp = await apiMethod.openCashDesk(deskId);
    if (methods.showApiErrors(resp)) {
      setCashDeskInfo(prevState => ({
        ...prevState,
        isActive: true
      }));
      setLoading(false);
      toast.success('باز کردن صندوق با موفقیت انجام شد.', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };

  const validCloseForm = () => {
    let errors = [];
    if (cashdeskReport.discrepancy != 0)
      if (methods.isNullOrEmptyString(cashdeskReport.description))
        errors.push('.در صورت مغایرت توضیحات باید مقدار داشته باشد');

    if (cashdeskReport.cashDeskId === 0)
      errors.push('.شناسه صندوق باید مقدار داشته باشد');

    if (errors.length > 0) {
      methods.showErrors(errors);
      return false;
    }
    return true;
  }

  const closeCashDesk = async () => {
    if (!validCloseForm())
      return false;

    setLoading(true);
    const resp = await apiMethod.closeCashDesk(cashdeskReport);
    if (methods.showApiErrors(resp)) {
      setCashDeskInfo(prevState => ({
        ...prevState,
        isActive: false,
      }));

      await getGridData(false);
      setShowCashDeskReportModal(false);

      setLoading(false);
      toast.success('بستن صندوق با موفقیت انجام شد.', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };

  const getActivityData = async (id) => {
    setActivityId(id)
    setLoading(true);
    const resp = await apiMethod.getDeskActivityInfo(id);
    setLoading(false);
    if (!methods.showApiErrors(resp))
      return false;
    mapActivity(resp.data);
    setShowCashDeskActivityModal(true);
  };

  const CreditDetails = async (activityId, unitId) => {
    setLoading(true);
    const resp = await apiMethod.getCashdeskCredits({ activityId, unitId })
    setLoading(false);
    setShow(unitId)
    if (!methods.showApiErrors(resp)) return false;
    setCreditDetailData(resp.data)
  }


  const movePagerPart = (isForward) => {
    if (isForward) {
      if (filterModel.parts < filterModel.part + 1) {
        return false;
      }
      callPager(filterModel.part + 1);
    } else {
      if (filterModel.part === 1) {
        return false;
      }
      callPager(filterModel.part - 1);
    }
  };

  const callPager = async (i) => {
    setLoading(true);
    filterModel.part = i;
    setFilterModel({ ...filterModel });
    await getGridData(false);
    setLoading(false);
  };

  const calcdiscrepancy = () => {
    let dis1 = cashdeskReport.posBalance - cashdeskReport.totalPosAmount;
    let dis2 = cashdeskReport.cashBalance - cashdeskReport.cashAmount;
    let dis3 = cashdeskReport.cardToCardBalance - cashdeskReport.cardToCardAmount;
    cashdeskReport.discrepancy = dis1 + dis2 + dis3;
    setCashdeskReport({ ...cashdeskReport });
  }

  const makePagerItems = () => {
    let pages = [];
    for (let i = 1; i <= filterModel.parts; i++) {
      pages.push(
        <li key={i} className={filterModel.part === i ? 'page-item active mx-1' : 'page-item mx-1'}>
          <a className="page-link circular-pagination" onClick={() => { callPager(i) }}>
            {i}
          </a>
        </li>
      );
    }
    return pages;
  };

  const openModal = async () => {
    await getCashDeskReport();
    setShowCashDeskReportModal(true);
  };

  const closeModal = () => {
    setShowCashDeskActivityModal(false);
    setShowCashDeskReportModal(false);
  };

  const calcCashierSaleAmount = () => {
    return cashdeskReport.salon.finalAmount + cashdeskReport.presence.finalAmount + cashdeskReport.delivery.finalAmount;
  }



  const renderItems = () => {
    return (
      <>
        {loading && <Preloading></Preloading>}
        {
          <>
            <div className='d-none d-lg-block'>
              <Link to={`/sale/${branchId}/cashDeskManage`} className='text-start mb-3 link back-link'>
                <span><img src={back} className="" alt="return" /></span>
                بازگشت
              </Link>
            </div>
            <div className='d-lg-none d-flex justify-content-between align-items-baseline saleheader'>
              <div>
                <Link to={`/sale/${branchId}/cashDeskManage`} className='link back-link'>
                  <span><img src={back} className="" alt="return" /></span>
                </Link>
                صندوق /عملکرد صندوق
              </div>
              <p className="date">{methods.currentDate()}</p>
            </div>
            <div className='saleheader d-none d-lg-block'>
              <p>صندوق /عملکرد صندوق</p>
            </div>
            <div className="salemain">
              <div className='salesearchsection'>
                <div className='row'>
                  <div className='col-12 col-md-3'>
                    <div className='flex-lg-row align-items-center justify-content-center '>
                      <p className='saleheader'>{cashDeskInfo && cashDeskInfo.title}</p>
                      <div className='d-flex align-items-center'>
                        <p className=''>وضعیت صندوق:</p>
                        <p className='cashstatus' style={{ width: '100px' }} >
                          <span className={`activecash ${cashDeskInfo.isActive ? 'activecash' : 'inActivecash'}`}></span>
                          <span className='px-3'>
                            {cashDeskInfo.isActive ? 'باز' : 'بسته'}
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className='col-12 col-md-3'></div>
                  <div className='col-12 col-md-3'></div>
                  <div className='col-12 col-md-3'>
                    <div className='createButton'>
                      {cashDeskInfo.isActive ?
                        <button
                          type="button"
                          className="btn custome-btn btn-purple salecreate"
                          onClick={openModal}
                        >
                          بستن صندوق
                          <i className="bi bi-lock fs-5 mt-2"></i>
                        </button>
                        :
                        <button
                          type="button"
                          className="btn custome-btn btn-green salecreate"
                          onClick={() => openCashDesk(cashDeskInfo.id)}
                        >بازکردن صندوق
                          <span className='align-middle'><i className="bi bi-unlock fs-5"></i></span>
                        </button>
                      }
                    </div>
                  </div>
                </div>
              </div>
              <div className='table-responsive'>
                <table className="table table-striped table-md " >
                  <thead className='align-middle'>
                    <tr>
                      <th width="20px">ردیف</th>
                      <th>صندوقدار</th>
                      <th>مغایرت</th>
                      <th >تاریخ</th>
                      <th width="250px" >توضیحات</th>
                      <th width="70px">گزارش</th>
                    </tr>
                  </thead>
                  <tbody className='align-middle'>
                    {gridData.map((item, index) => (
                      <tr key={index}>
                        <td scope="row">{((filterModel.part - 1) * filterModel.size) + index + 1}</td>
                        <td>{item.cashierName}</td>
                        <td>
                          {item.discrepancy < 0 &&
                            <b className='text-danger'>کسری: {methods.addNumSeperator(item.discrepancy * -1)}</b>
                          }
                          {item.discrepancy > 0 &&
                            <b className='text-success'>اضافه: {methods.addNumSeperator(item.discrepancy)}</b>
                          }
                          {item.discrepancy === 0 &&
                            <b>0</b>
                          }
                        </td>
                        <td>{methods.toPersianDate(item.endDate, 'jYYYY/jMM/jDD ساعت: HH:MM')}</td>
                        <td>{methods.textLimit(item.description, 20, " ...")}</td>
                        <td>
                          <button
                            onClick={() => getActivityData(item.id)}
                            className='btn btn-sm btn-outline-purple' type='button'>
                            <i className="bi bi-file-text"></i>
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {filterModel.parts > 1 &&
                  <nav aria-label="Page navigation example" className='mt-5'>
                    <ul className="pagination justify-content-center">
                      <li className="page-item mx-1">
                        <a className="page-link circular-pagination" onClick={() => { movePagerPart(false) }}>
                          <i className="bi bi-chevron-compact-right"></i>
                        </a>
                      </li>
                      {makePagerItems()}
                      <li className="page-item mx-1">
                        <a className="page-link circular-pagination" onClick={() => { movePagerPart(true) }}>
                          <i className="bi bi-chevron-compact-left"></i>
                        </a>
                      </li>
                    </ul>
                  </nav>
                }
              </div>
            </div>
          </>
        }
      </>
    )
  };

  const CashDeskReportModal = () => {
    return (
      <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: 'block' }}>
        <div className="modal-dialog modal-dialog modal-xl" role="document">
          <div className="modal-content px-3">
            <div className="modal-header">
              <h5 className="modal-title">اطلاعات فروش صندوق</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={closeModal}
              ></button>
            </div>
            <div className="modal-body">
              <div className='cashdeskreport mb-4'>
                <h5 className='mb-3'>پوزها</h5>
                <div className='table-responsive mb-4'>
                  <table className='table'>
                    <thead>
                      <tr>
                        <th>نام دستگاه</th>
                        <th>مبلغ فاکتورها</th>
                        <th>مبلغ انعام</th>
                        <th width="120px">استعلام حساب</th>
                        <th>مغایرت</th>
                        <th width="150px">توضیحات</th>
                        <th width="60px">عملیات</th>
                      </tr>
                    </thead>
                    <tbody>
                      {cashdeskReport.posDetails.map((item, index) => (
                        <tr key={index}>
                          <td>{item.title}</td>
                          <td>{methods.addNumSeperator(item.posAmount)}</td>
                          <td>{methods.addNumSeperator(item.tipAmount)}</td>
                          <td>
                            <div className='form-group'>
                              {methods.addNumSeperator(item.posInquiryAmount)}
                              {/* <input value={item.posInquiryAmount} onChange={(e) => {
                                cashdeskReport.posDetails[index].posInquiryAmount = e.target.value;
                                setCashdeskReport({ ...cashdeskReport });
                              }} type='text' className='form-control' /> */}
                            </div>
                          </td>
                          <td>
                            <span className='text-danger'>{methods.addNumSeperator(item.posInquiryAmount - item.posAmount)}</span>
                          </td>
                          <td>
                            <div className='form-gorup'>
                              <textarea id={'desc-item-' + item.id} value={item.description} onChange={(e) => {
                                item.description = e.target.value;
                                setCashdeskReport({ ...cashdeskReport });
                              }} type='text' className='form-control' rows={1}></textarea>
                            </div>
                          </td>
                          <td>
                            <div className='text-center'>
                              <button onClick={() => { getPosBalanceForCashDesk(item.id, index) }} className='btn btn-outline-purple btn-sm' title='استعلام از بانک'>
                                <i className="bi bi-wallet2"></i>
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className='table-responsive'>
                  <table className='table table-bordered'>
                    <tbody>
                      <tr>
                        <td>جمع فروش پوز</td>
                        <td>{methods.addNumSeperator(cashdeskReport.totalPosAmount)}</td>
                      </tr>
                      <tr>
                        <td>جمع انعام</td>
                        <td>{methods.addNumSeperator(cashdeskReport.posDetails.reduce((sum, curr) => sum = sum + curr.tipAmount, 0))}</td>
                      </tr>
                      <tr>
                        <td>جمع استعلام پوز</td>
                        <td>{methods.addNumSeperator(cashdeskReport.posDetails.reduce((sum, curr) => sum = sum + curr.posInquiryAmount, 0))}</td>
                      </tr>
                      <tr>
                        <td>جمع مغایرت پوز</td>
                        <td>{methods.addNumSeperator(cashdeskReport.posDetails.reduce((sum, curr) => sum = sum + (curr.posAmount - curr.posInquiryAmount), 0))}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div className='cashdeskreport mb-4'>
                <h5 className='mb-3'>سایر مبالغ</h5>
                <div className='table-responsive'>
                  <table className='table table-bordered'>
                    <tbody>
                      <tr>
                        <td>جمع فروش نقدی</td>
                        <td>{methods.addNumSeperator(cashdeskReport.cashAmount)}</td>
                        <td>مجموع شمارش نقدی:</td>
                        <td>
                          <div className='form-group'>
                            <input value={cashdeskReport.cashBalance} onChange={(e) => {
                              cashdeskReport.cashBalance = methods.convertToNumber(e.target.value);
                              setCashdeskReport({ ...cashdeskReport });
                              calcdiscrepancy();
                            }} type='text' className='form-control' />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>جمع فروش کارت به کارت</td>
                        <td>{methods.addNumSeperator(cashdeskReport.cardToCardAmount)}</td>
                        <td>موجودی حساب:</td>
                        <td>
                          <div className='form-group'>
                            <input value={cashdeskReport.cardToCardBalance} onChange={(e) => {
                              cashdeskReport.cardToCardBalance = methods.convertToNumber(e.target.value);
                              setCashdeskReport({ ...cashdeskReport });
                              calcdiscrepancy();
                            }} type='text' className='form-control' />
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div className='cashdeskreport mb-4'>
                <h5 className='mb-3'>فاکتورهای پرداخت نشده</h5>
                <div className='table-responsive'>
                  <table className='table table-bordered'>
                    <tbody>
                      <tr>
                        <td>جمع فاکتورها</td>
                        <td>{methods.addNumSeperator(cashdeskReport.unpaidInvoices.totalFinalPrice)}</td>
                        <td>تعداد فاکتور:</td>
                        <td>
                          {cashdeskReport.unpaidInvoices.totalCount}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div className='cashdeskreport'>
                <div className='table-responsive'>
                  <table className='table table-bordered'>
                    <tbody>
                      <tr>
                        <td>عناوین</td>
                        {cashdeskReport.unitsReport.map((item, index) => (
                          <td key={index}>{item.title}</td>
                        ))}
                      </tr>
                      <tr>
                        <td>فیش مهمان</td>
                        {cashdeskReport.unitsReport.map((item, index) => (
                          <td key={index}>{methods.addNumSeperator(item.guestAmount)}</td>
                        ))}
                      </tr>
                      <tr>
                        <td>شماره فاکتورها</td>
                        <td colSpan={cashdeskReport.unitsReport.length} className='text-end'>
                          {cashdeskReport.guestInvoices.map((item, index) => (
                            <>
                              <span key={index}>
                                {index === 0 &&
                                  <span>{item.invoiceNumber}</span>
                                }
                                {index > 0 &&
                                  <span> - {item.invoiceNumber}</span>
                                }
                              </span>
                            </>
                          ))}
                        </td>
                      </tr>
                      <tr>
                        <td>فیش جلب رضایت</td>
                        {cashdeskReport.unitsReport.map((item, index) => (
                          <td key={index}>{methods.addNumSeperator(item.satisfactionAmount)}</td>
                        ))}
                      </tr>
                      <tr>
                        <td>شماره فاکتورها</td>
                        <td colSpan={cashdeskReport.unitsReport.length} className='text-end'>
                          {cashdeskReport.satisfactionInvoices.map((item, index) => (
                            <>
                              <span key={index}>
                                {index === 0 &&
                                  <span>{item.invoiceNumber}</span>
                                }
                                {index > 0 &&
                                  <span> - {item.invoiceNumber}</span>
                                }
                              </span>
                            </>
                          ))}
                        </td>
                      </tr>
                      <tr>
                        <td>فیش تست غذا</td>
                        {cashdeskReport.unitsReport.map((item, index) => (
                          <td key={index}>{methods.addNumSeperator(item.foodTestAmount)}</td>
                        ))}
                      </tr>
                      <tr>
                        <td>شماره فاکتورها</td>
                        <td colSpan={cashdeskReport.unitsReport.length} className='text-end'>
                          {cashdeskReport.foodTestInvoices.map((item, index) => (
                            <>
                              <span key={index}>
                                {index === 0 &&
                                  <span>{item.invoiceNumber}</span>
                                }
                                {index > 0 &&
                                  <span> - {item.invoiceNumber}</span>
                                }
                              </span>
                            </>
                          ))}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div className='cashdeskreport'>
                <div className='table-responsive'>
                  <table className='table table-bordered'>
                    <tbody>
                      <tr>
                        <td>تاریخ شروع کار: {methods.toPersianDate(cashDeskInfo.openDate, 'jYYYY/jMM/jDD ساعت HH:mm')}</td>
                        <td>ثبت کننده: {cashdeskReport.creator}</td>
                      </tr>
                      <tr>
                        <td><b>مبلغ کل فروش:</b></td>
                        <td className='bg-dark text-light'><h5>{methods.addNumSeperator(calcCashierSaleAmount())}</h5></td>
                      </tr>
                      <tr>
                        <td className='bg-light'>
                          <h6>
                            کسری صندوق: {cashdeskReport.discrepancy < 0 &&
                              <span className='text-danger'>{methods.addNumSeperator(cashdeskReport.discrepancy * -1)}</span>
                            }
                            {cashdeskReport.discrepancy >= 0 && "0"}
                          </h6>
                        </td>
                        <td className='bg-light'>
                          <h6>
                            اضافه صندوق: {cashdeskReport.discrepancy > 0 &&
                              <span className='text-success'>{methods.addNumSeperator(cashdeskReport.discrepancy)}</span>
                            }
                            {cashdeskReport.discrepancy <= 0 && "0"}
                          </h6>
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={2}>
                          <div className='form-gorup'>
                            <textarea value={cashdeskReport.description} onChange={(e) => {
                              cashdeskReport.description = e.target.value;
                              setCashdeskReport({ ...cashdeskReport });
                            }} type='text' className='form-control' rows={3} placeholder='توضیحات'></textarea>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn custome-btn btn-link-purple "
                onClick={closeModal}
              >
                انصراف
              </button>
              <button
                type="button"
                className="btn custome-btn btn-purple"
                onClick={() => closeCashDesk()}
              >بستن صندوق</button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const CashDeskActivityModal = () => {
    return (
      <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: 'block' }}>
        <div className="modal-dialog modal-dialog modal-xl" role="document">
          <div className="modal-content px-3">
            <div className="modal-header">
              <h5 className="modal-title">گزارش فروش صندوق</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={closeModal}
              ></button>
            </div>
            <div className="modal-body">
              <div className='cashdeskreport mb-4'>
                <h5 className='mb-3'>پوزها</h5>
                <div className='table-responsive mb-4'>
                  <table className='table'>
                    <thead>
                      <tr>
                        <th>نام دستگاه</th>
                        <th>مبلغ فاکتورها</th>
                        <th>مبلغ انعام</th>
                        <th width="120px">استعلام حساب</th>
                        <th>مغایرت</th>
                        <th width="150px">توضیحات</th>
                      </tr>
                    </thead>
                    <tbody>
                      {deskActivityInfo.posDetails.map((item, index) => (
                        <tr key={index}>
                          <td>{item.Title}</td>
                          <td>{methods.addNumSeperator(item.PosAmount)}</td>
                          <td>{methods.addNumSeperator(item.TipAmount)}</td>
                          <td>
                            <div className='form-group'>
                              {item.PosInquiryAmount}
                            </div>
                          </td>
                          <td>{methods.addNumSeperator(item.PosAmount - item.PosInquiryAmount)}</td>
                          <td>
                            {item.Description}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className='table-responsive'>
                  <table className='table table-bordered'>
                    <tbody>
                      <tr>
                        <td>جمع فروش پوز</td>
                        <td>{methods.addNumSeperator(deskActivityInfo.posAmount)}</td>
                      </tr>
                      <tr>
                        <td>جمع انعام</td>
                        <td>{methods.addNumSeperator(deskActivityInfo.posDetails.reduce((sum, curr) => sum = sum + curr.TipAmount, 0))}</td>
                      </tr>
                      <tr>
                        <td>جمع استعلام پوز</td>
                        <td>{methods.addNumSeperator(deskActivityInfo.posDetails.reduce((sum, curr) => sum = sum + curr.PosInquiryAmount, 0))}</td>
                      </tr>
                      <tr>
                        <td>جمع مغایرت پوز</td>
                        <td>{methods.addNumSeperator(deskActivityInfo.posDetails.reduce((sum, curr) => sum = sum + (curr.PosAmount - curr.PosInquiryAmount), 0))}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="table-responsive">
                <table className="table table-bordered table-striped text-center">
                  <tbody>
                    <tr>
                      <td>تاریخ شروع کار: {methods.toPersianDate(deskActivityInfo.startDate, 'jYYYY/jMM/jDD ساعت HH:mm')}</td>
                      <td>تاریخ بستن: {methods.toPersianDate(deskActivityInfo.endDate, 'jYYYY/jMM/jDD ساعت HH:mm')}</td>
                      <td>ثبت کننده: {deskActivityInfo.creator}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div className="table-responsive mb-4">
                <table className="table table-bordered table-striped text-center">
                  <tbody>
                    <>
                      <tr>
                        <td colSpan={6}>
                          <h6>فروش کل شعبه</h6>
                        </td>
                      </tr>
                      <tr>
                        <td>نوع فروش</td>
                        <td>فروش خالص</td>
                        <td>مالیات بر ارزش افزوده</td>
                        <td>انعام</td>
                        <td>تخفیف</td>
                        <td>جمع کل</td>
                      </tr>
                      <tr>
                        <td>سالن</td>
                        <td>{methods.addNumSeperator(deskActivityInfo.salonDetail.NetAmount)}</td>
                        <td>{methods.addNumSeperator(deskActivityInfo.salonDetail.TaxAmount)}</td>
                        <td>{methods.addNumSeperator(deskActivityInfo.salonDetail.TipAmount)}</td>
                        <td>{methods.addNumSeperator(deskActivityInfo.salonDetail.DiscountAmount)}</td>
                        <td>{methods.addNumSeperator(deskActivityInfo.salonDetail.FinalAmount)}</td>
                      </tr>
                      <tr>
                        <td>مشترکین</td>
                        <td>{methods.addNumSeperator(deskActivityInfo.deliveryDetail.NetAmount)}</td>
                        <td>{methods.addNumSeperator(deskActivityInfo.deliveryDetail.TaxAmount)}</td>
                        <td>{methods.addNumSeperator(deskActivityInfo.deliveryDetail.TipAmount)}</td>
                        <td>{methods.addNumSeperator(deskActivityInfo.deliveryDetail.DiscountAmount)}</td>
                        <td>{methods.addNumSeperator(deskActivityInfo.deliveryDetail.FinalAmount)}</td>
                      </tr>
                      <tr>
                        <td>حضوری</td>
                        <td>{methods.addNumSeperator(deskActivityInfo.presenceDetail.NetAmount)}</td>
                        <td>{methods.addNumSeperator(deskActivityInfo.presenceDetail.TaxAmount)}</td>
                        <td>{methods.addNumSeperator(deskActivityInfo.presenceDetail.TipAmount)}</td>
                        <td>{methods.addNumSeperator(deskActivityInfo.presenceDetail.DiscountAmount)}</td>
                        <td>{methods.addNumSeperator(deskActivityInfo.presenceDetail.FinalAmount)}</td>
                      </tr>
                      <tr>
                        <td>اسنپ</td>
                        <td>{methods.addNumSeperator(deskActivityInfo.snappDetail.NetAmount)}</td>
                        <td>{methods.addNumSeperator(deskActivityInfo.snappDetail.TaxAmount)}</td>
                        <td>{methods.addNumSeperator(deskActivityInfo.snappDetail.TipAmount)}</td>
                        <td>{methods.addNumSeperator(deskActivityInfo.snappDetail.DiscountAmount)}</td>
                        <td>{methods.addNumSeperator(deskActivityInfo.snappDetail.FinalAmount)}</td>
                      </tr>
                      <tr>
                        <td>دلینو</td>
                        <td>{methods.addNumSeperator(deskActivityInfo.delinoDetail.NetAmount)}</td>
                        <td>{methods.addNumSeperator(deskActivityInfo.delinoDetail.TaxAmount)}</td>
                        <td>{methods.addNumSeperator(deskActivityInfo.delinoDetail.TipAmount)}</td>
                        <td>{methods.addNumSeperator(deskActivityInfo.delinoDetail.DiscountAmount)}</td>
                        <td>{methods.addNumSeperator(deskActivityInfo.delinoDetail.FinalAmount)}</td>
                      </tr>
                      <tr>
                        <td>اعتباری</td>
                        <td>{methods.addNumSeperator(deskActivityInfo.creditDetail.NetAmount)}</td>
                        <td>{methods.addNumSeperator(deskActivityInfo.creditDetail.TaxAmount)}</td>
                        <td>{methods.addNumSeperator(deskActivityInfo.creditDetail.TipAmount)}</td>
                        <td>{methods.addNumSeperator(deskActivityInfo.creditDetail.DiscountAmount)}</td>
                        <td>{methods.addNumSeperator(deskActivityInfo.creditDetail.FinalAmount)}</td>
                      </tr>
                    </>
                  </tbody>
                </table>
                <table className='table table-bordered table-striped text-center'>
                  <tbody>
                    <tr>
                      <td colSpan={3}>
                        <b>جزئیات فروش اعتباری</b>
                      </td>
                    </tr>
                    <tr>
                      <td>نام مشتری</td>
                      <td>جمع تخفیف</td>
                      <td>مجموع فروش</td>
                    </tr>
                    {deskActivityInfo.creditUserDetail.map((item, index) => (
                      <tr>
                        <td>{item.MerchantName}</td>
                        <td>{methods.addNumSeperator(item.DiscountAmount)}</td>
                        <td>{methods.addNumSeperator(item.FinalAmount)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className="table-responsive mb-4">
                <table className="table table-bordered table-striped text-center">
                  <tbody>
                    {deskActivityInfo.salesUnitObject.map((item, index) => (
                      <>
                        <tr>
                          <td colSpan={6}>
                            <h6>{item.Title}</h6>
                          </td>
                        </tr>
                        <tr>
                          <td>نوع فروش</td>
                          <td>فروش خالص</td>
                          <td>مالیات بر ارزش افزوده</td>
                          <td>انعام</td>
                          <td>تخفیف</td>
                          <td>جمع کل</td>
                        </tr>
                        <tr>
                          <td>سالن</td>
                          <td>{methods.addNumSeperator(item.Salon.NetAmount)}</td>
                          <td>{methods.addNumSeperator(item.Salon.TaxAmount)}</td>
                          <td>{methods.addNumSeperator(item.Salon.TipAmount)}</td>
                          <td>{methods.addNumSeperator(item.Salon.DiscountAmount)}</td>
                          <td>{methods.addNumSeperator(item.Salon.FinalAmount)}</td>
                        </tr>
                        <tr>
                          <td>مشترکین</td>
                          <td>{methods.addNumSeperator(item.Delivery.NetAmount)}</td>
                          <td>{methods.addNumSeperator(item.Delivery.TaxAmount)}</td>
                          <td>{methods.addNumSeperator(item.Delivery.TipAmount)}</td>
                          <td>{methods.addNumSeperator(item.Delivery.DiscountAmount)}</td>
                          <td>{methods.addNumSeperator(item.Delivery.FinalAmount)}</td>
                        </tr>
                        <tr>
                          <td>حضوری</td>
                          <td>{methods.addNumSeperator(item.Presence.NetAmount)}</td>
                          <td>{methods.addNumSeperator(item.Presence.TaxAmount)}</td>
                          <td>{methods.addNumSeperator(item.Presence.TipAmount)}</td>
                          <td>{methods.addNumSeperator(item.Presence.DiscountAmount)}</td>
                          <td>{methods.addNumSeperator(item.Presence.FinalAmount)}</td>
                        </tr>
                        <tr>
                          <td>اسنپ</td>
                          <td>{methods.addNumSeperator(item.Snapp.NetAmount)}</td>
                          <td>{methods.addNumSeperator(item.Snapp.TaxAmount)}</td>
                          <td>{methods.addNumSeperator(item.Snapp.TipAmount)}</td>
                          <td>{methods.addNumSeperator(item.Snapp.DiscountAmount)}</td>
                          <td>{methods.addNumSeperator(item.Snapp.FinalAmount)}</td>
                        </tr>
                        <tr>
                          <td>دلینو</td>
                          <td>{methods.addNumSeperator(item.Delino.NetAmount)}</td>
                          <td>{methods.addNumSeperator(item.Delino.TaxAmount)}</td>
                          <td>{methods.addNumSeperator(item.Delino.TipAmount)}</td>
                          <td>{methods.addNumSeperator(item.Delino.DiscountAmount)}</td>
                          <td>{methods.addNumSeperator(item.Delino.FinalAmount)}</td>
                        </tr>
                        <tr>
                          <td>
                            <button
                              className='btn btn-purple'
                              onClick={() => CreditDetails(activityId, item.UnitId)}
                            >اعتباری</button>
                          </td>
                          <td>{methods.addNumSeperator(item.Credit.NetAmount)}</td>
                          <td>{methods.addNumSeperator(item.Credit.TaxAmount)}</td>
                          <td>{methods.addNumSeperator(item.Credit.TipAmount)}</td>
                          <td>{methods.addNumSeperator(item.Credit.DiscountAmount)}</td>
                          <td>{methods.addNumSeperator(item.Credit.FinalAmount)}</td>
                        </tr>
                        {/* <button
                        className='btn btn-purple my-3'
                        onClick={() => CreditDetails(activityId , item.UnitId)}
                        >جزییات اعتباری</button> */}
                        <CreditDetailModal
                          show={show === item.UnitId}
                          onHide={handleClose}
                          data={creditDetailData}
                        />
                      </>
                    ))}
                  </tbody>
                </table>

              </div>
              <div className='table-responsive'>
                <table className='table table-bordered'>
                  <tbody>
                    <tr>
                      <td><b>مبلغ کل فروش:</b></td>
                      <td className='bg-dark text-light'><h5>{methods.addNumSeperator(deskActivityInfo.totalAmount)}</h5></td>
                    </tr>
                    <tr>
                      <td className='bg-light'>
                        <h6>
                          کسری صندوق: {deskActivityInfo.discrepancy < 0 &&
                            <span className='text-danger'>{methods.addNumSeperator(deskActivityInfo.discrepancy * -1)}</span>
                          }
                          {deskActivityInfo.discrepancy >= 0 && "0"}
                        </h6>
                      </td>
                      <td className='bg-light'>
                        <h6>
                          اضافه صندوق: {deskActivityInfo.discrepancy > 0 &&
                            <span className='text-success'>{methods.addNumSeperator(deskActivityInfo.discrepancy)}</span>
                          }
                          {deskActivityInfo.discrepancy <= 0 && "0"}
                        </h6>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan={2}>
                        {deskActivityInfo.description}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn custome-btn btn-link-purple "
                onClick={closeModal}
              >
                انصراف
              </button>
              <button
                type="button"
                className="btn custome-btn btn-purple"
              // onClick={() => closeCashDesk(cashDeskInfo.id)}
              >پرینت گزارش</button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {renderItems()}
      {showCashDeskReportModal && CashDeskReportModal()}
      {showCashDeskActivityModal && CashDeskActivityModal()}
    </>
  );
}

export default CashDeskOffRecord;